import type { PartnerInterestStatus } from '@/services/partnerInterests.service'

export const PARTNER_INTEREST_STATUSES = [
  'novo',
  'qualificando',
  'reuniao_agendada',
  'convite_enviado',
  'convertido',
  'perdido',
] as const satisfies readonly PartnerInterestStatus[]

export const PARTNER_INTEREST_STATUS_META: Record<
  PartnerInterestStatus,
  { label: string; className: string }
> = {
  novo: { label: 'Novo', className: 'bg-sky-100 text-sky-800' },
  qualificando: { label: 'Qualificando', className: 'bg-amber-100 text-amber-800' },
  reuniao_agendada: { label: 'Reunião agendada', className: 'bg-violet-100 text-violet-800' },
  convite_enviado: { label: 'Convite enviado', className: 'bg-blue-100 text-blue-800' },
  convertido: { label: 'Convertido', className: 'bg-emerald-100 text-emerald-800' },
  perdido: { label: 'Perdido', className: 'bg-rose-100 text-rose-800' },
}
